import LocoSection from './LocoSection'

export default class DieselLocoSection extends LocoSection {
    public fuelMassInTank = 0
    public fuelTemperatureInTank = 0
    public generatorFrequencyPerMinute = 0
    public refrigerantTemperature = 0
}
